import { axiosInstance } from '@/axios'
import config from '@/config.js'

export default {
  state: {
    classeUnitList: null
  },
  mutations: {
    SET_CLASSE_UNIT_LIST (state, classeUnitList) {
      // Get only units that not came from the library.
      state.classeUnitList = classeUnitList.filter(unit => unit.classes.filter(cls => cls.name !== 'FROM_LIBRARY').length)
    }
  },
  actions: {
    getClasseUnitList ({ commit }) {
      this.dispatch('setLoader', true)
      axiosInstance.get(config.classeApiUrl + 'units/collated/?type_user=1').then((response) => {
        const result = response.data
        commit('SET_CLASSE_UNIT_LIST', result)
        this.dispatch('setLoader', false)
      })
    },
    setClasseUnitList ({ commit }, val) {
      commit('SET_CLASSE_UNIT_LIST', val)
    }
  }
}
